import React, {PropTypes} from 'react';
import EstablishmentsRowMobile from './EstablishmentsRowMobile';

const EstablishmentsTableMobile = ({
  establishments,
  onSelectAll,
  onSelect,
  selectAllChecked,
  selectedEstablishments,
  hideStatus
}) => {

  if (establishments.length !== 0) {
    return (
      <div className="establishment-container mobile">
        <table className="table">
          <thead>
            <tr>
              <td colSpan="2">
                <h2>Establishments</h2>
              </td>
            </tr>
            <tr>
              <th className="checkbox-cell">
                <input
                  type="checkbox"
                  name="submit-reports-all"
                  onChange={onSelectAll}
                  checked={selectAllChecked}/>
              </th>
              <th className="establishment-info">Submit All Establishments</th>
            </tr>
          </thead>
          <tbody>
            {establishments.map((establishment) => {
              let evenRow = establishments.indexOf(establishment) % 2;
              return (<EstablishmentsRowMobile
                establishment={establishment}
                key={establishment.id}
                onSelect={onSelect}
                isSelected={selectedEstablishments[establishment.id] ?
                  true : false}
                evenRow={evenRow}
                hideStatus={hideStatus}/>);
            })
           }
          </tbody>
        </table>
      </div>
    );
  } else {
    return (
      <div className="establishment-container mobile">
        There are no available establishment records for this filter combination.
        Please either try filtering again or adding an establishment.
      </div>
    );
  }
};

EstablishmentsTableMobile.propTypes = {
  establishments: PropTypes.array.isRequired,
  onSelectAll: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  selectAllChecked: PropTypes.bool.isRequired,
  selectedEstablishments: PropTypes.object.isRequired,
  hideStatus: PropTypes.bool
};

export default EstablishmentsTableMobile;



/** WEBPACK FOOTER **
 ** ./src/components/establishment/EstablishmentsTable/EstablishmentsTableMobile.js
 **/